import "./logger-init";

import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { initMonitors } from "./initializers";
import { getEaLogger } from "./state";
import { env } from "./utils/env";

initMonitors();

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(<App />);

getEaLogger().child({ module: "index" }).info(`Config was loaded for '${env.envName}' environment.`);
